<template>
  <div class="d-flex flex-column align-center justify-center pa-8" style="gap: 24px">
    <v-icon color="error" size="64">mdi-alert-circle-outline</v-icon>

    <Typography as="h4" variant="h-4" class="text-center">Merge Failed</Typography>

    <Typography variant="body-1" class="text-center">
      Something went wrong while merging the accounts. No changes were made.
    </Typography>

    <Button color="brandCyan" class="white--text" @click="$emit('retry')">Try Again</Button>

    <v-divider style="width: 100%" />

    <CustomerServiceContact />
  </div>
</template>

<script>
import Button from "@/components/generic/Button.vue";
import Typography from "@/components/generic/Typography.vue";
import CustomerServiceContact from "@/components/help/CustomerServiceContact.vue";

export default {
  name: "MergeError",
  components: { Button, CustomerServiceContact, Typography },
  emits: ["retry"],
};
</script>
